import { render, staticRenderFns } from "./NotificationPreference.vue?vue&type=template&id=71ceef90&scoped=true&"
import script from "./NotificationPreference.vue?vue&type=script&lang=ts&"
export * from "./NotificationPreference.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationPreference.vue?vue&type=style&index=0&id=71ceef90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ceef90",
  null
  
)

export default component.exports